import { useCallback } from 'react'
import openNotification from 'utils/openNotification'
import useAuth from '../useAuth'
import { URL_API } from 'constants/api.constant'
import ApiService from 'services/ApiService'

const ERRORS_CODE = require('assets/maps/errors-code.json')
export default function useRequest () {
  const { signOut } = useAuth()

  const apiRequest = useCallback(async (params) => {
    try {
      const resp = await ApiService.fetchData(params);
      return { success: true, data: resp.data, message: '', code: null, error: null }
    } catch (error) {
      console.error('Error:', error)
      if (error?.response?.status === 403) {
        openNotification('danger', 'Sesion expirada', 'Por favor inicie sesion nuevamente');
        signOut()
      }

      if (error?.code === 'ERR_NETWORK') {
        return { success: false, message: 'Ocurrió un error en la red. Verifique su conexión a internet e intente nuevamente.', code: 'ERR_NETWORK', error, data: null }
      }

      const message = ERRORS_CODE[error?.response?.data?.code] || 'Ocurrió un error inesperado. Contacte al administrador del sistema.'
      // `code` expuesto aparte del mensaje: quien llama necesita distinguir un
      // fallo transitorio (reintentable) de uno permanente — p.ej. el escriba
      // ambiental deja de reintentar si la cuota de IA se agotó.
      return { success: false, message, code: error?.response?.data?.code || null, error, data: null }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const get = useCallback(async (path, options = {}) => {
    const { url = URL_API, ...rest } = options;
    return await apiRequest({
      url: `${url}${path}`,
      method: 'GET',
      ...rest
    });
  }, [apiRequest]);

  const post = useCallback(async (path, options = {}) => {
    const { data, url = URL_API, ...rest } = options;
    return await apiRequest({
      url: `${url}${path}`,
      method: 'POST',
      data,
      ...rest,
    });
  }, [apiRequest]);

  const put = useCallback(async (path, options = {}) => {
    const { data, url = URL_API, ...rest } = options;
    return await apiRequest({
      url: `${url}${path}`,
      method: 'PUT',
      data,
      ...rest,
    });
  }, [apiRequest]);

  const patch = useCallback(async (path, options = {}) => {
    const { data, url = URL_API, ...rest } = options;
    return await apiRequest({
      url: `${url}${path}`,
      method: 'PATCH',
      data,
      ...rest,
    });
  }, [apiRequest]);

  const remove = useCallback(async (path, options = {}) => {
    const { url = URL_API, ...rest } = options;
    return await apiRequest({
      url: `${url}${path}`,
      method: 'DELETE',
      ...rest,
    });
  }, [apiRequest]);

  return {
    get,
    post,
    put,
    patch,
    delete: remove
  }
}
